import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

class TimelineXS extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: props.data
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    })
  }
  render() {
    let data, anchor
    if (this.state && this.state.data) {
      data = this.state.data
      anchor = this.state.data.anchor
    }

    return (
      <section className="main-grid center" id="timeline">
        <ul className="grid group" >
          <h3 className="mg-bottom">Timeline</h3>

          <li className="grid-small group">
            <div className='grid-mini'>
              <h6 className="grid-section-title">2016 December</h6>
              <div className="grid-section-body">
                <p className="grid-section-data"><b>12.15</b></p>
                <p className=""><b>Kohai written application open</b></p>
              </div>
            </div>
            <div className='grid-mini inner-right-large'>
              <h6 className="grid-section-title">2017 March</h6>
              <div className="grid-section-body">
                <p className="grid-section-data"><b>3.31</b></p>
                <p className=""><b>Kohai interviews start</b></p>
              </div>
            </div>
          </li>

          <li className="grid-small grid-middle group">
            <div className='grid-mini'>
              <h6 className="grid-section-title">April</h6>
              <div className="grid-section-body">
                <p className="grid-section-data"><b>4.31</b></p>
                <p className=""><b>Kohai groups announced (rolling)</b></p>
              </div>
            </div>
            <div className='grid-mini inner-right-large'>
              <h6 className="grid-section-title">July</h6>
              <div className="grid-section-body">
                <p className="grid-section-data"><b>7.9 - 7.22</b></p>
                <p className=""><b>Camps in France & Romania</b></p>
              </div>
            </div>
          </li>

          <li className="grid-small group">
            <div className='grid-small'>
              <h6 className="grid-section-title">August</h6>
              <div className="grid-section-body">
                <p className="grid-section-data"><b>8.5 - 8.18</b></p>
                <p className=""><b>Camps in Bali & Japan</b></p>
              </div>
            </div>
          </li>
        </ul>
      </section>
    )
  }
}
TimelineXS.contextTypes = {
}
TimelineXS.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location
    //data: state.token.data
  }
}

export default connect(mapStateToProps)(TimelineXS)



// WEBPACK FOOTER //
// ./src/components/OurStory/TimelineXS.js